var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_316_5651)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6606 12.9242H1.33918C1.04286 12.9242 0.803467 13.1636 0.803467 13.46V14.0626C0.803467 14.1363 0.863735 14.1966 0.937395 14.1966H14.0624C14.1361 14.1966 14.1963 14.1363 14.1963 14.0626V13.46C14.1963 13.1636 13.9569 12.9242 13.6606 12.9242ZM3.24264 11.518C3.27612 11.518 3.30961 11.5146 3.34309 11.5096L6.15894 11.0158C6.19242 11.0091 6.22423 10.994 6.24766 10.9689L13.3442 3.87235C13.3597 3.85686 13.372 3.83847 13.3804 3.81821C13.3888 3.79796 13.3932 3.77625 13.3932 3.75432C13.3932 3.7324 13.3888 3.71069 13.3804 3.69044C13.372 3.67018 13.3597 3.65179 13.3442 3.6363L10.5618 0.85226C10.53 0.820452 10.4882 0.803711 10.443 0.803711C10.3978 0.803711 10.3559 0.820452 10.3241 0.85226L3.22757 7.9488C3.20246 7.97391 3.1874 8.00405 3.1807 8.03753L2.68684 10.8534C2.67055 10.9431 2.67637 11.0354 2.70379 11.1223C2.73121 11.2092 2.77941 11.2882 2.8442 11.3523C2.95469 11.4594 3.09365 11.518 3.24264 11.518ZM4.37099 8.59835L10.443 2.52804L11.6701 3.75516L5.59811 9.82548L4.10983 10.0883L4.37099 8.59835Z",
    fill: "#2F90CC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_316_5651"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.fe04f4b65b8f8ea0d5e2a49bdb7e1011.svg";
export { ForwardRef as ReactComponent };